import { Card, CardContent, MenuItem, Stack, Typography } from "@mui/material";
import { useFormContext  } from "react-hook-form";
import { PollingScheduleForm, PollingScheduleFormListItem } from "./ModifyPollingScheduleUtils";
import FormSelect from "../forms/form-select/FormSelect";
import { useTranslation } from "react-i18next";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { useObjectPropertyLists } from "../../queries/object-properties/UseObjectPropertyLists";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { IeLynxObject } from "../../common/models/eLynxObject";

export type TagPollingScheduleListItemProps = {
    item: PollingScheduleFormListItem,
    onChanged?: (item: PollingScheduleFormListItem, value: number) => void;
}

export function TagPollingScheduleListItem({
    item,
    onChanged
}: TagPollingScheduleListItemProps) {

    const {t} = useTranslation();


    const routeContext = useRouteContext();

    const { data: referenceData } = useQueryNotifications(useObjectPropertyLists)({
        groupID: routeContext.groupID as number,
        eLynxObject: routeContext.contextObject as IeLynxObject
    });


    const {
        watch,
    } = useFormContext<PollingScheduleForm>();    
    
    const [watchItems] = watch(['pollingSchedules']);

    // we need the 'real' index of the item
    //const index = watchItems.findIndex(o => o.id  === item.id);
    const index = watchItems.findIndex(o => o.tagID  === item.tagID);
                        
    function renderItem() {

            return (
                <Stack
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flex: '1 1 auto',
                        padding: 1
                    }}>
                    <Typography
                        variant='body2'
                        sx={{
                            flexBasis: '60%',
                            textDecoration: !item.tagVisible ? 'line-through' : undefined
                        }}>
                        {item.tagName}
                    </Typography>
                    <FormSelect
                        name={`pollingSchedules.${index}.scheduleID`}
                        label={t('properties.interval')}
                        sx={{ 
                            flexBasis: '40%'
                        }}
                        onChange={(e) => onChanged && onChanged(item, +e.target.value)}
                    >
                        {referenceData?.tagPollingSchedules?.map((value, index) =>
                            <MenuItem key={index} value={value.id}>
                                {value.description}
                            </MenuItem>
                        )}

                    </FormSelect>
                </Stack>
            );
    }

    return (
        <Card variant="outlined">
            <CardContent sx={{
                padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
            }}>
                { renderItem() }
            </CardContent>
        </Card>
    );
}
